<script lang="ts">
    import {api} from "src/services/api/reallis"
    import {validateEmail, navigate} from "src/components/main/#common/helpers"
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import Alert from 'src/components/main/#common/alert/Alert.svelte'
    import IconifyIcon from '@iconify/svelte'
    import facebookIcon from '@iconify/icons-fa-brands/facebook'
    import googleIcon from '@iconify/icons-fa-brands/google'
    import hideIcon from '@iconify/icons-fa-solid/eye'
    import showIcon from '@iconify/icons-fa-solid/eye-slash'
    import {onDestroy, onMount} from 'svelte'
    import {isLoggedIn} from 'src/services/auth'
    import learnMore from 'src/components/main/#assets/learn-more.svg'
    import uIcon from 'src/components/#assets/u.svg'
    import spirale from 'src/components/#assets/spirale.png'
    import elipse from 'src/components/#assets/elipse.png'
    import realisId from 'src/components/main/#assets/realis-id.svg'
    import menuArrow from 'src/components/#assets/menu-arrow.svg'
    import FacebookLogin from "svelte-facebook-login"
    import 'src/components/main/#common/oauth/google/oauthGoogleCallback.ts'
    import {showAlert} from "src/components/main/#common/alert/store"
    import {sendCredential} from 'src/components/main/#services/socialAuth'

    export let hash = null

    const urlParams = new URLSearchParams(window.location.search)

    let step = 1
    let email = ''
    let password = ''
    let referralCode = urlParams.has('ref') ? urlParams.get('ref') : ''
    if (localStorage.getItem('referral')) {
        referralCode = localStorage.getItem('referral')
    }
    let confirmationCode = ''
    let sending = false
    let resetSending = false
    let errorStatus = false
    let errorText = ''
    let enterCode = false
    let passwordHash = ''
    let emailHash = ''
    let showPassword = false
    let showReferralCode = false
    let sendEmailRemainingSeconds = 0
    let sendEmailDatetime

    $: email, sendEmailDatetime = 0
    sendEmailDatetime = parseInt(localStorage.getItem('sendEmailDatetime') || '0')
    $: localStorage.setItem('sendEmailDatetime', sendEmailDatetime+'')

    emailHash = localStorage.getItem('emailHash')
    $: localStorage.setItem('emailHash', emailHash)

    onMount(()=>{
        if (hash) {
            step = 0
            register()
        }
    })

    let sendEmailTimer = setInterval(() => {
        sendEmailRemainingSeconds = Math.ceil(Math.max(0, 60000 - (Date.now() - sendEmailDatetime)) / 1000)
    }, 1000)

    onDestroy(()=>{
        clearInterval(sendEmailTimer)
    })

    async function register() {
        if (step == 0) {
            try {
                sending = true
                errorStatus = false
                const result = await api.ws.ws1.request({
                    data: {
                        agent: "auth",
                        auth: {type: "webSite"},
                        lang: "en",
                        method: "auth_confirmEmailByHash",
                        params: {
                            "hash": hash
                        }
                    }
                })
                passwordHash = result.result.response.value
                step = 3
            } catch (err) {
                navigate("/register")
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: "Link has been expired"
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            } finally {
                sending = false
                hash = null

            }
        } else if (step == 1) {
            if (!email) {
                errorStatus = true
                errorText = 'Enter your Email'
                return
            }

            if (!validateEmail(email)) {
                errorStatus = true
                errorText = 'Please enter a valid email'
                return
            }

            if (email.includes('+')) {
                errorStatus = true
                errorText = 'Email can\'t have special characters'
                return
            }

            if (sendEmailRemainingSeconds > 0) {
                step = 2
                return
            }

            try {
                sending = true
                resetSending = true
                errorStatus = false

                emailHash = null

                const result = await api.ws.ws1.request({
                    data:{
                        agent: "auth",
                        auth: {type: "webSite"},
                        lang: "en",
                        method: "auth_createRequestToConfirmEmail",
                        params: {
                            "email": email,
                            "referralCode": referralCode
                        }
                    }
                })
                step = 2
                emailHash = result.result.response.value?.emailHash
                sendEmailDatetime = Date.now()
            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            } finally {
                sending = false
                resetSending = false
            }
        } else if (step == 2) {

            if (!confirmationCode) {
                errorStatus = true
                errorText = 'Enter confirmation code'
                return
            }

            if (confirmationCode.length != 6) {
                errorStatus = true
                errorText = 'Confirmation code must be 6 characters'
                return
            }


            try {
                sending = true
                errorStatus = false
                const result = await api.ws.ws1.request({
                    data: {
                        agent: "auth",
                        auth: {type: "webSite"},
                        lang: "en",
                        method: "auth_confirmEmailByCode",
                        params: {
                            "code": confirmationCode,
                            "emailHash": emailHash
                        }
                    }
                })
                emailHash = null
                passwordHash = result.result.response.value?.passHash
                step = 3

            } catch (err) {
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            } finally {
                sending = false
                hash = null
            }
        } else if (step == 3) {
            if (password.length < 8) {
                errorStatus = true
                errorText = 'Password must be at least 8 characters'
                return
            }
            try {
                sending = true
                errorStatus = false

                const result = await api.ws.ws1.request({
                    data: {
                        agent: "auth",
                        auth: {type: "webSite"},
                        lang: "en",
                        method: "auth_setPassword",
                        params: {
                            "passwordHash": passwordHash,
                            "password": password,
                        }
                    }
                })
            }catch (err){
                if (err.message) {
                    showAlert.set({
                        status: 'error',
                        text: err.message
                    })
                } else {
                    showAlert.set({
                        status: 'error',
                        text: 'An Error Occurred, Please Try Again Later'
                    })
                }
            } finally {
                sending = false
            }
        }
    }

    async function resendEmail() {
        try {
            resetSending = true
            emailHash = null
            const result = await api.ws.ws1.request({
                data: {
                    agent: "auth",
                    auth: {type: "webSite"},
                    lang: "en",
                    method: "auth_resentConfirmationMail",
                    params: {
                        "email": email
                    }
                }
            })
            emailHash = result.result.response.value?.emailHash
            showAlert.set({
                status: 'success',
                text: 'We have resent a confirmation to your Email'
            })
            sendEmailDatetime = Date.now()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            resetSending = false
        }
    }
    async function back() {
        if (step > 1) {
            errorStatus = false
            errorText = ''
            step = 1
        }
        const result = await api.ws.ws1.request({
            data: {
                agent: "auth",
                auth: {type: "webSite"},
                lang: "en",
                method: "auth_deleteEmailRequest",
                params: {
                    "emailHash": emailHash
                }
            }
        })
    }

    async function facebookAuthSuccess(params) {
        try {
            await sendCredential.request({ data: { provider: 'facebook', credential: params.detail.code } })
        } catch (err) {
            console.error(err)
            if (err.message.includes('ban')) {
                showAlert.set({
                    status: 'error',
                    text: 'Your Account Has Been Banned',
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'Facebook authorization error',
                })
            }
        }
    }

    function facebookAuthError(error) {
        showAlert.set({
            status: 'error',
            text  : error.detail.message,
        })
    }

    $: if ($isLoggedIn) {
        navigate("/account")
    }
</script>

<svelte:head>
    <title>Register</title>
    <script src="https://apis.google.com/js/platform.js" async defer></script>
    <script src="https://accounts.google.com/gsi/client" async defer></script>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="panel-wrapper">
            <div class="container">
                <div class="auth-background"></div>
                <div class="auth-wrapper">
                    <img src="{elipse}" class="elipse" alt="">
                    <img src="{spirale}" class="spirale" alt="">
                    <img src="{uIcon}" class="u-icon" alt="">
                    <img src="{realisId}" class="realis-id" alt="realis id">
                    <form class:d-none={enterCode} on:submit|preventDefault={register} novalidate>
                        <Alert />
                        {#if step !== 1 && email}
                            <div class="back" on:click={back}>
                                <img src="{learnMore}" alt="">Back
                            </div>
                        {/if}
                        {#if step === 1}
                            <div class="auth-social-buttons">
                                <div id="g_id_onload"
                                     data-client_id="492902765781-hf4ck2a3v69vh2vhvjjleul09tvposgm.apps.googleusercontent.com"
                                     data-callback="oauthGoogleCallback">
                                </div>
                                <div class="g_id_signin"
                                     data-type="standard"
                                     data-size="large"
                                     data-theme="fill_black"
                                     data-text="sign_in_with"
                                     data-shape="rectangular"
                                     data-logo_alignment="left"
                                     data-width="416"
                                     data-height="56">
                                </div>
                                <div class="auth-social-btn auth-google-btn">
                                    <div class="auth-social-icon">
                                        <IconifyIcon icon={googleIcon}/>
                                    </div>
                                    <div class="auth-social-text">Sign up with Google</div>
                                </div>
                                <FacebookLogin
                                    clientId="424456532882971"
                                    state="1"
                                    scope="email"
                                    redirectUri={process.env.FACEBOOK_REDIRECT_URL}
                                    on:success={params => facebookAuthSuccess(params)}
                                    on:error={error => facebookAuthError(error)}
                                    let:onLogin>
                                    <div class="auth-social-btn auth-facebook-btn" on:click={onLogin}>
                                        <div class="auth-social-icon">
                                            <IconifyIcon icon={facebookIcon} class="social-icon"/>
                                        </div>
                                        <div class="auth-social-text">Sign up with Facebook</div>
                                    </div>
                                </FacebookLogin>
                            </div>
                            <div class="or"><span>or</span></div>
                            <div class="input-group">
                                <input type="email" class="form-control field"
                                    placeholder="E-mail" autocomplete="email" required bind:value={email}>
                            </div>
                            <div class="referral-code-accordion" on:click={() => showReferralCode = !showReferralCode}>
                                Referral code (optional) <img src="{menuArrow}" class:rotate-180={!showReferralCode} alt="">
                            </div>
                            {#if showReferralCode}
                                <div class="input-group">
                                    <input type="text" class="form-control field" placeholder="Referral code"
                                        autocomplete="none" bind:value={referralCode}>
                                </div>
                            {/if}
                            <div class="text-center mb-4">
                                <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                                <button class="input-group-text btn btn-primary auth-button {sending ? 'loading' : ''}"
                                    disabled={sending} type="submit"><span>Next</span></button>
                            </div>
                            <div class="have-account">Already have an account? <Link to="login">Log in</Link></div>
                        {/if}
                        {#if step === 2}
                            <div class="input-group">
                                <div class="info-text">We have sent a confirmation code to <strong>{email}</strong></div>
                            </div>
                            <div class="input-group">
                                <input type="text" class="form-control field" placeholder="Confirmation code"
                                    autocomplete="none" required bind:value={confirmationCode} autofocus>
                            </div>
                            <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                            <div class="input-group">
                                <button type="submit" class="input-group-text btn btn-primary auth-button {sending ? 'loading' : ''}"
                                    disabled={sending}><span>Confirm</span></button>
                            </div>
                            <div class="input-group">
                                <button type="button" class="input-group-text btn btn-secondary resend-btn {resetSending && sendEmailRemainingSeconds === 0 ? 'loading' : ''}"
                                    disabled={resetSending || sendEmailRemainingSeconds > 0} on:click={resendEmail}>
                                    {#if sendEmailRemainingSeconds > 0}
                                        <span class="seconds">{sendEmailRemainingSeconds}</span>
                                    {/if}Resend code
                                </button>
                            </div>
                            <div class="have-account">Already have an account? <Link to="login">Log in</Link></div>
                        {/if}
                        {#if step === 3}
                            <div class="input-group">
                                <div class="info-text">Set a password for your account</div>
                            </div>
                            <div class="input-group">
                                <div class="position-relative" style="width: 100%;">
                                    {#if showPassword === true}
                                        <input type="text" class="form-control field" placeholder="Password" required
                                           autocomplete="none" bind:value={password} autofocus>
                                    {:else}
                                        <input type="password" class="form-control field" placeholder="Password" required
                                           autocomplete="none" bind:value={password} autofocus>
                                    {/if}
                                    <button type="button" class="show-hide-password" on:click={() => { showPassword = !showPassword }}>
                                        <IconifyIcon icon={showPassword ? showIcon : hideIcon}/>
                                    </button>
                                </div>
                            </div>
                            <div class="text-center mb-4">
                                <div class="invalid-feedback {errorStatus ? 'd-block' : ''}">{errorText}</div>
                                <button type="submit" class="input-group-text btn btn-primary auth-button {sending ? 'loading' : ''}"
                                    disabled={sending}><span>Log in</span></button>
                            </div>
                        {/if}
                        <div class="auth-form-terms">
                            By using, you agree to the <Link to="terms" class="link">Terms of Use</Link>,
                            <Link to="policy" class="link">Privacy Policy</Link>, the processing and storage of cookies
                            and agree to the newsletter from Realis.
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .container {
        position: relative;
    }

    .realis-id {
        margin: 0 auto 35px;
        display: block;
        width: 80px;
        height: 106px;
    }

    .referral-code-accordion {
        font-size: 14px;
        color: #A0AEC0;
        display: table;
        user-select: none;
        margin: 10px 0;
        cursor: pointer;
    }

    .referral-code-accordion img {
        opacity: 0.5;
    }

    .auth-background {
        background: linear-gradient(220deg, rgba(44, 43, 64, 0.15) 23%, #1E1920 50%);
        filter: blur(200px);
        width: calc(100% - 24px);
        height: 550px;
        position: absolute;
    }

    .auth-wrapper {
        background: #27232C;
        border-radius: 10px;
        border: 2px solid #7B7DB3;
        max-width: 480px;
        margin: 60px auto 150px;
        padding: 35px 40px;
        z-index: 2;
        position: relative;
    }

    .auth-wrapper .back {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        margin: 0 0 40px;
        display: table;
        position: absolute;
        top: 40px;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;
    }

    .auth-wrapper .back img {
        margin-right: 10px;
        transform: rotate(-90deg);
        vertical-align: top;
        margin-top: 2px;
        transition: .25s;
    }

    .auth-wrapper .back:hover img {
        transform: rotate(-135deg);
    }

    .resend-btn :global(*) {
        font-size: 12px;
        color: #A0AEC0;
        line-height: 14px;
        font-weight: 500;
        width: 25px;
        min-width: 29px;
        height: 29px;
        border: 2px solid #929095;
        border-radius: 50%;
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        margin: -6px 10px -4px 0;
        padding: 6px 0;
    }

    .auth-wrapper .resend-btn {
        position: relative;
        width: 100%;
        margin: 10px 0 20px;
        padding: 12px 15px;
    }

    .auth-wrapper .form-control {
        border: 1px solid #7B7DB3;
        border-radius: 3px;
        box-shadow: none !important;
    }

    .title {
        position: relative;
        text-align: center;
        color: white;
        line-height: 30px;
        margin: 10px 0 50px;
        font-size: 30px;
    }

    .auth-social-buttons {
        margin-bottom: 20px;
        text-decoration: none;
        position: relative;
        transition: .25s;
    }

    .auth-social-btn {
        text-decoration: none;
        display: flex;
        color: #fff;
        height: 56px;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        position: relative;
        max-width: 550px;
        border: 1px solid #B8BAFD;
        margin: 0 auto 20px;
        text-align: center;
        transition: .25s;
        cursor: pointer;
    }

    .auth-social-btn:hover {
        background: rgb(54 46 60);
    }

    .g_id_signin:hover + .auth-google-btn {
        background: rgb(54 46 60);
    }

    .auth-form-terms {
        font-size: 13px;
        line-height: 19px;
        color: #A0AEC0;
        margin: 30px 0 10px;
        font-weight: 200;
    }

    .auth-form-terms :global(.link) {
        color: #A0AEC0;
        transition: .25s;
    }

    .auth-form-terms :global(.link):hover {
        color: white;
    }

    .have-account {
        font-size: 14px;
        color: white;
    }

    .have-account :global(a) {
        color: #2F80ED;
        margin-left: 5px;
        font-weight: 500;
        text-decoration: none;
        border-bottom: 1px solid #2F80ED;
    }

    .input-group {
        max-width: 550px;
        margin: 10px auto;
    }

    .auth-social-text {
        font-size: 18px;
    }

    .auth-social-icon {
        font-size: 28px;
        margin-right: 10px;
    }

    .or {
        margin: 28px auto;
        max-width: 550px;
        font-size: 18px;
        line-height: 27px;
        color: #A0AEC0;
        text-align: center;
        position: relative;
    }

    .or span {
        padding: 0 10px;
        background: #27232C;
        position: relative;
        z-index: 2;
    }

    .or:before {
        content: "";
        height: 2px;
        width: 100%;
        background: rgba(160, 174, 192, 0.3);
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -1px;
    }

    .auth-button {
        width: 100%;
        margin-top: 20px;
        padding: 17px 45px !important;
        font-weight: 500;
    }

    a {
        color: gray;
        text-decoration: none;
        position: center;
    }

    label {
        max-width: 600px;
        float: left;
        margin: 5px 0;
        color: white;
        font-size: 15px;
        line-height: 30px;
        position: relative;
        bottom: 50px;
    }

    input {
        margin: 5px 0;
        position: center;
    }

    .info-text {
        color: white;
        font-size: 16px;
        font-weight: 300;
        word-break: break-word;
        line-height: 24px;
    }

    .info-text strong {
        font-weight: 500;
    }

    .seconds {
        font-size: 12px;
    }

    .auth-wrapper :global(.alert) {
        font-size: 14px;
        margin-bottom: 20px;
        text-align: left;
        padding: 15px 45px 15px 15px;
    }

    .show-hide-password {
        position: absolute;
        background: none;
        right: 1px;
        top: 6px;
        height: 48px;
        width: 48px;
        color: #464957;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        z-index: 2;
    }

    .elipse {
        position: absolute;
        z-index: 2;
        left: -289px;
        top: -63px;
        -webkit-user-drag: none;
    }

    .spirale {
        position: absolute;
        z-index: 2;
        right: -320px;
        top: 330px;
        -webkit-user-drag: none;
    }

    .u-icon {
        position: absolute;
        z-index: 2;
        top: 574px;
        left: -180px;
        -webkit-user-drag: none;
    }

    .btn.btn-primary {
        margin: 5px auto 0;
    }

    .g_id_signin {
        position: absolute;
        width: 100%;
        height: 56px;
        z-index: 2;
        opacity: 0;
        cursor: pointer;
        overflow: hidden;
    }

    .g_id_signin :global [role="button"] {
        height: 56px;
    }

    .g_id_signin :global iframe {
        margin: 0 !important;
        width: 100% !important;
        height: 56px !important;
    }

    @media(max-width: 1400px) {
        .spirale {
            right: -250px;
        }
    }

    @media(max-width: 991px) {
        .spirale {
            right: -130px;
        }

        .auth-social-text {
            font-size: 16px;
        }

        .auth-social-icon {
            font-size: 26px;
        }

        .auth-social-btn {
            height: 48px;
        }

        .auth-wrapper .form-control {
            padding: 11px 24px;
        }

        .g_id_signin {
            height: 48px;
        }

        .g_id_signin :global [role="button"] {
            height: 48px;
        }

        .g_id_signin :global iframe {
            height: 48px !important;
        }
    }

    @media(max-width: 767px) {
        .title {
            line-height: 20px;
            margin: 0 0 30px;
            font-size: 20px;
        }

        .or {
            font-size: 18px;
            margin: 20px auto;
        }

        .auth-social-text {
            font-size: 15px;
        }

        .resend-btn {
            padding: 11px 16px!important;
            margin-right: 0 !important;
        }

        .info-text {
            font-size: 14px;
            line-height: 21px;
        }

        .resend-btn :global(*) {
            font-size: 10px;
            top: 1px;
            right: 5px;
        }

        .spirale,
        .elipse,
        .u-icon {
            display: none;
        }

        .auth-wrapper {
            margin: 20px auto -20px;
            padding: 30px;
        }

        .auth-social-btn {
            height: 40px;
            margin: 0 auto 10px;
        }

        .auth-social-icon {
            font-size: 20px;
        }

        .auth-wrapper .form-control {
            padding: 8px 20px;
            font-size: 16px;
            margin: 0;
        }

        .auth-button {
            padding: 12px 15px !important;
            margin-top: 10px;
        }

        .auth-form-terms {
            font-size: 12px;
            line-height: 17px;
            margin: 20px 0 0;
        }

        .auth-wrapper .back {
            margin: 0 0 20px;
        }

        .show-hide-password {
            height: 39px;
            width: 39px;
            top: 1px;
        }

        .g_id_signin {
            height: 40px;
        }

        .g_id_signin :global [role="button"] {
            height: 40px;
        }

        .g_id_signin :global iframe {
            height: 40px !important;
        }

        .realis-id {
            margin: 0 auto 30px;
            width: 54px;
            height: auto;
        }
    }
</style>
